var ImageUploadModel = /** @class */ (function () {
    function ImageUploadModel() {
    }
    return ImageUploadModel;
}());
export { ImageUploadModel };
//# sourceMappingURL=image-upload.model.js.map